<!-- Cancel Subscription  -->
<p-dialog
  [visible]="visible()"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [breakpoints]="{ '767px': '100vw' }"
  [style]="{ width: '600px' }"
  [contentStyle]="{ padding: '0', overflow: 'hidden' }"
  styleClass="no-header-modal subscription-cancel-dialog"
>
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <form
      [formGroup]="CancelSubscriptionForm"
      (ngSubmit)="CancelSubscription()"
      class="flex flex-column"
    >
      <!-- Header -->
      <div
        class="px-4 py-3 flex align-items-center justify-content-between border-bottom-1 border-300 surface-0"
      >
        <h2 class="mb-0 text-base font-bold">
          {{ 'SUBSCRIPTION_CANCEL.CANCEL_SUBS' | translate }}
        </h2>
        <button
          type="button"
          class="p-button p-button-text p-button-rounded p-button-plain w-2rem h-2rem p-0"
          (click)="closePopup(false)"
          aria-label="close-subscription-cancel-dialog"
          data-testid="close-subscription-cancel-dialog"
        >
          <i class="fa fa-times text-xl text-600" aria-hidden="true"></i>
        </button>
      </div>
      <!-- Header -->

      <!-- Scrollable content -->
      <div class="subscription-cancel-body surface-100 overflow-y-auto">
        <!-- Alerts -->
        <div class="px-3 pt-3 flex flex-column gap-2">
          <p-message
            severity="warn"
            icon="fa fa-exclamation-triangle"
            styleClass="w-full text-sm"
            aria-label="subscription-cancel-info-message"
            data-testid="subscription-cancel-info-message"
          >
            {{ 'SUBSCRIPTION_CANCEL.INFO' | translate }}
          </p-message>
          <p-message
            severity="info"
            styleClass="w-full text-sm"
            aria-label="subscription-cancel-refund-info-message"
            data-testid="subscription-cancel-refund-info-message"
          >
            {{ 'SUBSCRIPTION_CANCEL.REFUND_INFO' | translate }}
          </p-message>
        </div>

        <div class="p-3">
          <!-- Cancellation type -->
          <div class="mb-3">
            <label 
              for="cancel-type-label"
              id="cancel-type-label"
              class="font-medium text-700 text-xs mb-2 block uppercase"
            >
              {{ 'SUBSCRIPTION_CANCEL.CHOOSE_TYPE' | translate }}
              <sup class="p-error">*</sup>
            </label>

            <div
              class="grid formgrid m-0"
              role="radiogroup"
              aria-labelledby="cancel-type-label"
            >
              <div class="col-12 sm:col-6 p-1">
                <div
                  class="subscription-cancel-option flex align-items-start border-1 border-round p-2 h-full cursor-pointer transition-colors transition-duration-150"
                  [ngClass]="
                    selectedCancelType === 'ImmediateCancel'
                      ? 'border-primary surface-0 shadow-1'
                      : 'border-300 surface-0 hover:surface-50'
                  "
                  (click)="GetCancelType('ImmediateCancel')"
                >
                  <p-radioButton
                    name="cancel_type"
                    value="ImmediateCancel"
                    inputId="option1"
                    formControlName="cancel_type"
                    aria-label="cancel-immediately-option"
                  />
                  <label for="option1" class="ml-2 text-sm line-height-3 cursor-pointer">
                    {{ 'SUBSCRIPTION_CANCEL.IMMEDIIETLY' | translate }}
                  </label>
                </div>
              </div>

              @if (ShowEndOfBillingButton) {
                <div class="col-12 sm:col-6 p-1">
                  <div
                    class="subscription-cancel-option flex align-items-start border-1 border-round p-2 h-full cursor-pointer transition-colors transition-duration-150"
                    [ngClass]="
                      selectedCancelType === 'EndOfBillingPeriod'
                        ? 'border-primary surface-0 shadow-1'
                        : 'border-300 surface-0 hover:surface-50'
                    "
                    (click)="GetCancelType('EndOfBillingPeriod')"
                  >
                    <p-radioButton
                      name="cancel_type"
                      value="EndOfBillingPeriod"
                      inputId="option2"
                      formControlName="cancel_type"
                      aria-label="cancel-end-of-billing-option"
                    />
                    <label for="option2" class="ml-2 text-sm line-height-3 cursor-pointer">
                      {{ 'SUBSCRIPTION_CANCEL.END_OF_BILLING' | translate }}
                    </label>
                  </div>
                </div>
              }

              @if (ShowEndOfContractButton) {
                <div class="col-12 sm:col-6 p-1">
                  <div
                    class="subscription-cancel-option flex align-items-start border-1 border-round p-2 h-full cursor-pointer transition-colors transition-duration-150"
                    [ngClass]="
                      selectedCancelType === 'EndOfContract'
                        ? 'border-primary surface-0 shadow-1'
                        : 'border-300 surface-0 hover:surface-50'
                    "
                    (click)="GetCancelType('EndOfContract')"
                  >
                    <p-radioButton
                      name="cancel_type"
                      value="EndOfContract"
                      inputId="option3"
                      formControlName="cancel_type"
                      aria-label="cancel-end-of-contract-option"
                    />
                    <label for="option3" class="ml-2 text-sm line-height-3 cursor-pointer">
                      {{ 'SUBSCRIPTION_CANCEL.END_OF_CONTRACT' | translate }}
                    </label>
                  </div>
                </div>
              }

              <div class="col-12 sm:col-6 p-1">
                <div
                  class="subscription-cancel-option flex align-items-start border-1 border-round p-2 h-full cursor-pointer transition-colors transition-duration-150"
                  [ngClass]="
                    selectedCancelType === 'Custom'
                      ? 'border-primary surface-0 shadow-1'
                      : 'border-300 surface-0 hover:surface-50'
                  "
                  (click)="GetCancelType('Custom')"
                >
                  <p-radioButton
                    name="cancel_type"
                    value="Custom"
                    inputId="option4"
                    formControlName="cancel_type"
                    aria-label="cancel-custom-date-option"
                  />
                  <label for="option4" class="ml-2 text-sm line-height-3 cursor-pointer">
                    {{ 'SUBSCRIPTION_CANCEL.CUSTOM' | translate }}
                  </label>
                </div>
              </div>

              <div class="col-12 sm:col-6 p-1">
                <div
                  class="subscription-cancel-option flex align-items-start border-1 border-round p-2 h-full cursor-pointer transition-colors transition-duration-150"
                  [ngClass]="
                    selectedCancelType === 'EarliestSubscriptionCancellationDate'
                      ? 'border-primary surface-0 shadow-1'
                      : 'border-300 surface-0 hover:surface-50'
                  "
                  (click)="GetCancelType('EarliestSubscriptionCancellationDate')"
                >
                  <p-radioButton
                    name="cancel_type"
                    value="EarliestSubscriptionCancellationDate"
                    inputId="option5"
                    formControlName="cancel_type"
                    aria-label="cancel-earliest-subscription-cancellation-date-option"
                  />
                  <label for="option5" class="ml-2 text-sm line-height-3 cursor-pointer">
                    {{ 'SUBSCRIPTION_CANCEL.EARLIEST_SUBSCRIPTION_CANCELLATION_DATE' | translate }}
                  </label>
                </div>
              </div>

              <div class="col-12 sm:col-6 p-1">
                <div
                  class="subscription-cancel-option flex align-items-start border-1 border-round p-2 h-full cursor-pointer transition-colors transition-duration-150"
                  [ngClass]="
                    selectedCancelType === 'ImmediateRecent'
                      ? 'border-primary surface-0 shadow-1'
                      : 'border-300 surface-0 hover:surface-50'
                  "
                  (click)="GetCancelType('ImmediateRecent')"
                >
                  <p-radioButton
                    name="cancel_type"
                    value="ImmediateRecent"
                    inputId="option6"
                    formControlName="cancel_type"
                    aria-label="cancel-immediate-recent-option"
                  />
                  <label for="option6" class="ml-2 text-sm line-height-3 cursor-pointer">
                    {{ 'SUBSCRIPTION_CANCEL.IMMEDIATE_RECENT' | translate }}
                  </label>
                </div>
              </div>
            </div>
          </div>

          <!-- Cancellation date -->
          @if (!showDatePicker) {
            <div class="mb-3">
              <label
                for="cancel-date-label"
                class="font-medium text-700 text-xs mb-2 block uppercase"
              >
                {{ 'SUBSCRIPTION_CANCEL.CANCEL_DATE' | translate }}
              </label>
              <div
                class="surface-0 border-1 border-300 border-round px-3 py-2"
                aria-label="cancellation-date-summary"
                data-testid="cancellation-date-summary"
              >
                @if (isPreviewLoading) {
                  <span
                    class="text-sm text-600"
                    aria-label="earliest-cancellation-date-loading"
                    data-testid="earliest-cancellation-date-loading"
                  >
                    <i class="fa fa-spinner fa-spin mr-2" aria-hidden="true"></i>
                    {{ 'SUBSCRIPTION_CANCEL.LOADING_DATE' | translate }}
                  </span>
                } @else if (
                  selectedCancelType === 'EarliestSubscriptionCancellationDate' &&
                  earliestCancellationDate
                ) {
                  <div
                    class="flex align-items-center justify-content-between gap-2"
                    aria-label="earliest-cancellation-date-value"
                    data-testid="earliest-cancellation-date-value"
                  >
                    <strong class="text-sm">{{ cancellationDate | date: 'd MMM yy' }}</strong>
                    <span class="text-xs text-600 white-space-nowrap">
                      {{ 'SUBSCRIPTION_CANCEL.' + text | translate }}
                    </span>
                  </div>
                } @else if (selectedCancelType !== 'EarliestSubscriptionCancellationDate') {
                  <div class="flex align-items-center justify-content-between gap-2">
                    <strong class="text-sm">{{ cancellationDate | date: 'd MMM yy' }}</strong>
                    <span class="text-xs text-600 white-space-nowrap">
                      {{ 'SUBSCRIPTION_CANCEL.' + text | translate }}
                    </span>
                  </div>
                }
              </div>
            </div>
          }

          @if (showDatePicker) {
            <div class="mb-3">
              <label
                for="custom-cancellation-date"
                class="font-medium text-700 text-xs mb-2 block uppercase"
              >
                {{ 'SUBSCRIPTION_CANCEL.SELECT_DATE' | translate }}
                <sup class="p-error">*</sup>
              </label>
              <p-datepicker
                formControlName="custom_date"
                [minDate]="minDate"
                dateFormat="dd M yy"
                [showIcon]="true"
                inputId="custom-cancellation-date"
                aria-label="custom-cancellation-date-picker"
                (onSelect)="onCustomDateChange($event)"
                styleClass="w-full"
                appendTo="body"
              />
              @if (selectedCancelType === 'ImmediateRecent' && isValidatingDate) {
                <small
                  class="text-xs block mt-2 text-600"
                  aria-label="immediate-recent-date-validating"
                  data-testid="immediate-recent-date-validating"
                >
                  <i class="fa fa-spinner fa-spin mr-1" aria-hidden="true"></i>
                  {{ 'SUBSCRIPTION_CANCEL.VALIDATING_DATE' | translate }}
                </small>
              }
              @if (
                selectedCancelType === 'ImmediateRecent' &&
                !isValidatingDate &&
                immediateRecentValidationMessage
              ) {
                <small
                  class="text-xs block mt-2"
                  [ngClass]="isImmediateRecentDateValid ? 'text-green-600' : 'p-error'"
                  aria-label="immediate-recent-date-validation-message"
                  data-testid="immediate-recent-date-validation-message"
                >
                  <i
                    class="fa mr-1"
                    [ngClass]="
                      isImmediateRecentDateValid
                        ? 'fa-check-circle'
                        : 'fa-exclamation-circle'
                    "
                    aria-hidden="true"
                  ></i>
                  {{ immediateRecentValidationMessage }}
                </small>
              }
            </div>
          }

          <!-- Reason -->
          <div class="mb-3">
            <label
              for="cancellation-reason-dropdown"
              class="font-medium text-700 text-xs mb-2 block uppercase"
            >
              {{ 'SUBSCRIPTION_CANCEL.SELECT_REASON' | translate }}
              <sup class="p-error">*</sup>
            </label>
            <p-select
              [options]="cancellationReasons"
              formControlName="cancellation_reason_master"
              optionLabel="reason_primary_language"
              [placeholder]="'SUBSCRIPTION_CANCEL.SELECT_REASON_PLACEHOLDER' | translate"
              [filter]="true"
              appendTo="body"
              filterBy="reason_primary_language,reason_secondary_language"
              inputId="cancellation-reason-dropdown"
              aria-label="cancellation-reason-dropdown"
              class="w-full"
              [ngClass]="{
                'ng-invalid ng-dirty':
                  CancellationReasonMasterFormControl.touched &&
                  CancellationReasonMasterFormControl.invalid,
              }"
            >
              <ng-template let-reason pTemplate="item">
                <div>
                  {{
                    translate.currentLang === 'ar'
                      ? reason.reason_secondary_language
                      : reason.reason_primary_language
                  }}
                </div>
              </ng-template>
              <ng-template let-reason pTemplate="selectedItem">
                <div>
                  {{
                    translate.currentLang === 'ar'
                      ? reason.reason_secondary_language
                      : reason.reason_primary_language
                  }}
                </div>
              </ng-template>
            </p-select>
            @if (
              CancellationReasonMasterFormControl.touched &&
              CancellationReasonMasterFormControl.invalid
            ) {
              <small
                class="p-error text-xs block mt-1"
                aria-label="cancellation-reason-required-error"
                data-testid="cancellation-reason-required-error"
              >
                {{ 'SUBSCRIPTION_CANCEL.SELECT_REASON_REQUIRED' | translate }}
              </small>
            }
          </div>

          <div>
            <label
              for="cancellation-additional-reason"
              class="font-medium text-700 text-xs mb-2 block uppercase"
            >
              {{ 'SUBSCRIPTION_CANCEL.CANCEL_REASON' | translate }}
            </label>
            <textarea
              pInputTextarea
              id="cancellation-additional-reason"
              class="w-full text-sm"
              rows="3"
              formControlName="reason"
              [placeholder]="'SUBSCRIPTION_CANCEL.REASON' | translate"
              aria-label="cancellation-additional-reason"
            ></textarea>
          </div>
        </div>
      </div>
      <!-- Scrollable content -->

      <!-- Footer -->
      <div
        class="px-4 py-3 flex justify-content-between align-items-center border-top-1 border-300 surface-0"
      >
        <button
          pButton
          pRipple
          type="button"
          [label]="'SUBSCRIPTION_CANCEL.CANCEL' | translate"
          class="p-button-text text-sm"
          (click)="closePopup(false)"
          aria-label="subscription-cancel-dismiss-button"
        ></button>
        <button
          pButton
          pRipple
          type="submit"
          [loading]="isFormSubmitting || isPreviewLoading || isValidatingDate"
          [disabled]="!canSubmitCancellation"
          [label]="'SUBSCRIPTION_CANCEL.BTN_CANCEL' | translate"
          class="text-sm"
          aria-label="subscription-cancel-submit-button"
        ></button>
      </div>
      <!-- Footer -->
    </form>
  </ng-template>
</p-dialog>
<!-- Cancel Subscription  -->
